import dateRange from './date-range.vue';
import dateSepRange from './date-separate-range.vue';

export default [dateRange, dateSepRange];
